import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Star } from "lucide-react";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-32 pb-20">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,fit=crop/dJobQe0laqSVpB88/amb1-AVLaZ31PXOSW9xxV.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#0056c5]/10 backdrop-blur-sm border border-[#0056c5]/20 rounded-full px-4 py-2 mb-6">
            <Star className="h-4 w-4 text-[#0056c5] fill-[#0056c5]" />
            <span className="text-sm font-medium text-white">Top Medical Cover in Surrey & Sussex</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Professional Medical Coverage
            <span className="block text-[#0056c5] mt-2">You Can Trust</span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Expert medical and first aid support for marathons, festivals, motorsports, and events. 
            Trained NHS professionals with state-of-the-art equipment ensuring safety and peace of mind.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-[#0056c5] hover:bg-[#004399] text-white px-8 py-6 text-lg font-semibold group"
            >
              Request Quote
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => {
                const element = document.getElementById("training");
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#0056c5] px-8 py-6 text-lg font-semibold"
            >
              View Training Courses
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-12 pt-12 border-t border-white/20">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#0056c5] mb-2">100+</div>
              <div className="text-sm text-gray-300">Events Covered</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#0056c5] mb-2">24/7</div>
              <div className="text-sm text-gray-300">Emergency Response</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#0056c5] mb-2">NHS</div>
              <div className="text-sm text-gray-300">Experienced Team</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
